<template>
    <div class="devices-container d-flex flex-column">
        <DeviceCommand ref="command-modal"></DeviceCommand>
        <DeviceSettings ref="settings-modal"></DeviceSettings>
        <ItemDevice
            v-for="device in deviceInfo"
            :key="device?.id"
            :device="device"
            @command="openCommands"
            @settings="openSettings"
        ></ItemDevice>
    </div>
</template>
<script lang="ts">
import ItemDevice from '@/components/ItemDevice.vue'
import DeviceCommand from '@/components/modals/DeviceCommand.vue'
import DeviceSettings from '@/components/modals/DeviceSettings.vue'
import IDeviceView from '@/models/modelView/IDeviceView'
import devicesModule from '@/store/modules/devices.module'
import globalModule from '@/store/modules/global.module'
import DeviceUtil from '@/utils/device.util'
import { Component, Vue } from 'vue-property-decorator'

@Component({
    components: {
        ItemDevice,
        DeviceCommand,
        DeviceSettings,
    },
})
export default class Devices extends Vue {
    get deviceInfo() {
        return devicesModule.deviceInfo
    }

    mounted() {
        globalModule.updateBodySize()
        console.log('mounted devices')
    }

    openCommands(device: IDeviceView) {
        const modal: any = this.$refs['command-modal']
        modal.deviceIcon = device.icon
        modal.devicePlate = device.plate
        modal.deviceId = device.id
        modal.show()
    }

    async openSettings(device: IDeviceView) {
        const modal: any = this.$refs['settings-modal']
        const moduleDevice = await devicesModule.getDevicebyId(device.id)
        const params: any = moduleDevice?.attributes?.params || {}
        modal.deviceId = device.id
        modal.plate = device.plate
        modal.icon = device.icon
        modal.speedLimit = DeviceUtil.formatKnToKmh(moduleDevice?.attributes?.speedLimit || 0)
        modal.fuel_type = params?.fuelType || params?.fuel_type || ''
        modal.fuel_efficiency = params?.fuelEfficiency || params?.fuel_efficiency || ''
        modal.fuel_cost = params?.fuelCost || params?.fuel_cost || ''
        modal.show()
    }
}
</script>
<style lang="sass" scoped>
.devices-container
  overflow-y: auto
  border: 2px solid rgba(40, 84, 239, .7)!important
</style>
